import { render, staticRenderFns } from "./BtnResponsaveisPadrao.vue?vue&type=template&id=9a2bc04e"
import script from "./BtnResponsaveisPadrao.vue?vue&type=script&lang=js"
export * from "./BtnResponsaveisPadrao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports